import { render, staticRenderFns } from "./GlobalSearchDestinations.vue?vue&type=template&id=ff8fae5e&"
import script from "./GlobalSearchDestinations.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchDestinations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports